<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >RPA执行记录</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="虚拟机"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.selectMac"
                                    :options="toolbar.macOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="状态"
                            field="status"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="运行中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="4"
                                        label="运行异常"
                                    ></vxe-option>
                                    <vxe-option
                                        value="5"
                                        label="运行完成"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            v-if="$store.state.isAdmin == '1'"
                            title="跟进状态"
                            field="followStatus"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.followStatus"
                                    placeholder="全部"
                                    clearable
                                    style="width: 110px"
                                >
                                    <vxe-option value="0" label="未跟进"></vxe-option>
                                    <vxe-option value="1" label="跟进中"></vxe-option>
                                    <vxe-option value="2" label="已解决"></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入流程名称或ID"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :cell-style="cellStyle"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable1"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="日志" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-search-plus"
                                    @click="viewLog(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="操作" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    v-if="row.StateName == '运行中'"
                                    type="text"
                                    icon="fa fa-stop"
                                    @click="stopEvent(row)"
                                    title="停止流程"
                                ></vxe-button>
                                <vxe-button
                                    v-else
                                    type="text"
                                    icon="fa fa-play"
                                    @click="startEvent(row)"
                                    status="success"
                                    title="重新执行"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="跟进"
                            width="70"
                            show-overflow
                            :visible="$store.state.isAdmin == '1'"
                        >
                            <template #default="{ row }">
                                <span
                                    v-if="
                                        row.StateName == '运行异常' &&
                                        (row.followStatus == '1' ||
                                            row.followStatus == '跟进中')
                                    "
                                    class="follow-status follow-status--processing"
                                    title="编辑跟进信息"
                                    @click="openFollow(row)"
                                    >跟进中</span
                                >
                                <span
                                    v-else-if="
                                        row.StateName == '运行异常' &&
                                        (row.followStatus == '2' ||
                                            row.followStatus == '已解决')
                                    "
                                    class="follow-status follow-status--resolved"
                                    @click="openFollow(row)"
                                    >已解决</span
                                >
                                <vxe-button
                                    v-else-if="row.StateName == '运行异常'"
                                    type="text"
                                    icon="fa fa-edit"
                                    title="编辑跟进信息"
                                    @click="openFollow(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="StateName"
                            title="状态"
                            width="100"
                            align="center"
                        ></vxe-column>
                        <vxe-column
                            title="邮箱"
                            width="200"
                            show-overflow
                            resizable
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="vxe-icon-copy"
                                    title="复制共享目录地址"
                                    @click="copyUser(row.CreatorUserId)"
                                ></vxe-button>
                                {{ row.CreatorUserId }}
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="UserName"
                            title="姓名"
                            width="100"
                            align="center"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="ProcessKey"
                            title="流程ID"
                            width="130"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="流程名称"
                            width="220"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="Abbr"
                            title="机器简称"
                            width="110"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="StartTime"
                            title="开始时间"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="EndTime"
                            title="结束时间"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="MachineName"
                            title="机器人"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="EnvironmentName"
                            title="部署环境"
                            width="150"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="CoeTeacher"
                            title="CoE导师"
                            width="100"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="DevelopUser"
                            title="开发者"
                            width="100"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="DevPlatform"
                            title="开发平台"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="Key"
                            title="Key"
                            width="160"
                            :visible="false"
                        ></vxe-column>
                        <vxe-column
                            field="processID"
                            title="processID"
                            width="160"
                            :visible="false"
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>

            <vxe-modal
                title="日志明细"
                v-model="logForm.iShow"
                width="900"
                maskClosable
                resize
                show-zoom
            >
                <template #default>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="logForm.dtLog"
                            ref="xTableUser"
                            height="300"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="id"
                                title="序号"
                                width="60"
                            ></vxe-column>
                            <vxe-column title="状态" width="60">
                                <template #default="{ row }">
                                    <span>{{
                                        row.Level == "Info" ? "信息" : "错误"
                                    }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column
                                field="ProcessName"
                                title="流程ID"
                                width="140"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="RobotName"
                                title="机器人"
                                width="160"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="Message"
                                title="信息"
                                width="400"
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="TimeStamp"
                                title="操作时间"
                                width="160"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                ref="followModal"
                title="执行异常跟进"
                v-model="followForm.iShow"
                width="760"
                :loading="followForm.loading"
                :show-footer="true"
                destroy-on-close
            >
                <template #default>
                    <div class="follow-form">
                        <div class="follow-form__item follow-form__item--full">
                            <label>详细错误信息 (Traceback):</label>
                            <pre class="traceback">{{
                                followForm.traceback || "暂无错误信息"
                            }}</pre>
                        </div>
                        <div class="follow-form__row">
                            <div class="follow-form__item">
                                <label>错误类别:</label>
                                <vxe-select
                                    v-model="followForm.errorType"
                                    placeholder="请选择错误类别"
                                >
                                    <vxe-option
                                        value="元素问题"
                                        label="元素问题"
                                    ></vxe-option>
                                    <vxe-option
                                        value="权限问题"
                                        label="权限问题"
                                    ></vxe-option>
                                    <vxe-option
                                        value="操作问题"
                                        label="操作问题"
                                    ></vxe-option>
                                    <vxe-option
                                        value="账号过期"
                                        label="账号过期"
                                    ></vxe-option>
                                    <vxe-option
                                        value="服务器问题"
                                        label="服务器问题"
                                    ></vxe-option>
                                    <vxe-option
                                        value="业务要求终止"
                                        label="业务要求终止"
                                    ></vxe-option>
                                    <vxe-option
                                        value="组件问题"
                                        label="组件问题"
                                    ></vxe-option>
                                    <vxe-option
                                        value="业务系统问题"
                                        label="业务系统问题"
                                    ></vxe-option>
                                    <vxe-option
                                        value="代码问题"
                                        label="代码问题"
                                    ></vxe-option>
                                    <vxe-option
                                        value="浏览器问题"
                                        label="浏览器问题"
                                    ></vxe-option>
                                </vxe-select>
                            </div>
                            <div class="follow-form__item">
                                <label>跟进状态:</label>
                                <vxe-select
                                    v-model="followForm.followStatus"
                                    placeholder="请选择跟进状态"
                                >
                                    <vxe-option
                                        value="1"
                                        label="跟进中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="已解决"
                                    ></vxe-option>
                                </vxe-select>
                            </div>
                        </div>
                        <div class="follow-form__item follow-form__item--full">
                            <label>原因分析与解决方案:</label>
                            <vxe-textarea
                                v-model="followForm.solution"
                                placeholder="请输入原因分析与解决方案"
                                :autosize="{ minRows: 5, maxRows: 8 }"
                            ></vxe-textarea>
                        </div>
                    </div>
                </template>
                <template #footer>
                    <vxe-button @click="followForm.iShow = false"
                        >取消</vxe-button
                    >
                    <vxe-button status="primary" @click="saveFollow"
                        >提交保存</vxe-button
                    >
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive } from "vue";
import XEUtils from "xe-utils";
import { VXETable, VxeTableInstance, VxeTablePropTypes } from "vxe-table";

export default {
    name: "JobList",
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            macOptions: [],
            formData: {
                selectMac: "",
                status: "",
                searchKey: "",
                followStatus: "",
            },
        });

        const logForm = reactive({
            dtLog: [],
            iShow: false, //显示更新包
            pager: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            },
        });
        const followForm = reactive({
            iShow: false,
            loading: false,
            jobId: "",
            traceback: "",
            errorType: "",
            followStatus: "1",
            solution: "",
        });
        const cellStyle = ({ row, column }) => {
            if (column.field === "StateName") {
                if (row.StateName === "运行完成") {
                    return {
                        color: "#008000",
                    };
                } else if (row.StateName === "运行异常") {
                    return {
                        color: "#FF0000",
                    };
                } else {
                    return {
                        color: "#0000FF",
                    };
                }
            }
        };

        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            logForm,
            followForm,
            cellStyle,
            tableHeight: 0,
        };
    },
    methods: {
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.status,
                    this.toolbar.formData.selectMac,
                    "",
                    this.toolbar.formData.followStatus,
                ],
            };
            this.$api.jobManageAPI
                .getJobsList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    // debugger;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        viewLog(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 10,
                searchKey: ["", "", "", "", row.Key],
            };
            this.$api.jobManageAPI
                .getLogsList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.logForm.dtLog = res.data.Data.dataTable;
                    this.logForm.iShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        openFollow(row) {
            this.followForm.jobId = row.Id;
            this.followForm.errorType = row.errorType;
            this.followForm.followStatus = String(
                row.followStatus === null || row.followStatus === undefined
                    ? ""
                    : row.followStatus
            );
            this.followForm.solution = row.solution;
            this.followForm.iShow = true;
            this.$nextTick(this.disableFollowAutofill);
            this.followForm.traceback = "";
            if (!this.followForm.traceback) {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    currentPage: 1,
                    pageSize: 100,
                    searchKey: ["", "", "", "", row.Key],
                };
                this.$api.jobManageAPI
                    .getLogsList(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success && res.data.Data) {
                            const logs = res.data.Data.dataTable || [];
                            const errorLog = logs.find(
                                (item) => item.Level !== "Info"
                            );
                            this.followForm.traceback = errorLog
                                ? errorLog.Message
                                : logs.length
                                ? logs[logs.length - 1].Message
                                : "";
                        }
                    });
            }
        },
        disableFollowAutofill() {
            const modal = this.$refs.followModal;
            const modalElement = modal && modal.$el ? modal.$el : null;
            if (!modalElement) {
                return;
            }

            modalElement.setAttribute("data-form-type", "other");
            modalElement
                .querySelectorAll("input, textarea")
                .forEach((element, index) => {
                    element.setAttribute("autocomplete", "new-password");
                    element.setAttribute("data-form-type", "other");
                    element.setAttribute("data-lpignore", "true");
                    element.setAttribute("data-1p-ignore", "true");
                    element.setAttribute("name", `job-follow-field-${index}`);
                });
        },
        saveFollow() {
            if (!this.followForm.errorType) {
                VXETable.modal.message({
                    content: "请选择错误类别",
                    status: "warning",
                });
                return;
            }
            if (!this.followForm.followStatus) {
                VXETable.modal.message({
                    content: "请选择跟进状态",
                    status: "warning",
                });
                return;
            }
            if (!this.followForm.solution || !this.followForm.solution.trim()) {
                VXETable.modal.message({
                    content: "请输入原因分析与解决方案",
                    status: "warning",
                });
                return;
            }
            this.followForm.loading = true;
            const params = {
                jobId: this.followForm.jobId,
                errorType: this.followForm.errorType,
                followStatus: this.followForm.followStatus,
                solution: this.followForm.solution,
                uid: this.$store.state.userID,
                email: this.$store.state.email,
            };
            this.$api.jobManageAPI
                .saveJobFollow(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "跟进信息保存成功",
                        status: "success",
                    });
                    this.followForm.iShow = false;
                    this.findData();
                })
                .catch((error) => {
                    VXETable.modal.message({
                        content: error.message || "保存失败",
                        status: "error",
                    });
                })
                .finally(() => {
                    this.followForm.loading = false;
                });
        },
        async stopEvent(row) {
            const type = await VXETable.modal.confirm("您确定要停止该作业吗?");

            if (type === "confirm") {
                this.$api.jobManageAPI
                    .stopJob(Qs.stringify({ jobId: row.Id }))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "停止成功",
                            status: "success",
                        });
                        this.findData();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        // 重新执行
        async startEvent(row) {
            const type = await VXETable.modal.confirm(
                "您确定要重新执行该作业吗?"
            );

            if (type === "confirm") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    actionType: "1",
                    actionKey: [row.processID, this.$store.state.userName],
                };
                this.$api.jobManageAPI
                    .startProcess(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        // console.log(res.data.Data);
                        setTimeout(function () {
                            this.findData();
                        }, 10000);
                        VXETable.modal.message({
                            content: "重新执行成功",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });

                        console.log(error);
                    });
            }
        },
        bindPC() {
            this.$api.systemManageAPI
                .getMachineList()
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.PcName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        copyUser(email) {
            navigator.clipboard
                .writeText(
                    "\\\\172.28.61.13\\hd_is_rpa\\RPA程序共享文件夹\\" + email
                )
                .then(function () {
                    VXETable.modal.message({
                        content: "地址已复制",
                        status: "success",
                    });
                })
                .catch(function (err) {
                    console.error("复制文本失败: ", err);
                });
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
            this.toolbar.formData.selectMac = "";
            this.toolbar.formData.followStatus = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        formatTime(cellValue) {
            return XEUtils.toDateString(cellValue, "yyyy-MM-dd HH:ss:mm");
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
    },
    mounted() {
        this.bindPC();
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style scoped>
.active {
    color: green;
    font-weight: bold;
}

.error {
    color: red;
    font-weight: bold;
}

.audit {
    color: blue;
    font-weight: bold;
}

.follow-form {
    padding: 4px 0 8px;
}

.follow-status {
    white-space: nowrap;
}

.follow-status--processing {
    color: #e6a23c;
    cursor: pointer;
}

.follow-status--resolved {
    color: #67c23a;
    cursor: pointer;
}

.follow-form__row {
    display: flex;
    gap: 20px;
}

.follow-form__item {
    flex: 1;
    margin-bottom: 20px;
}

.follow-form__item label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
}

.follow-form__item .vxe-select,
.follow-form__item .vxe-textarea {
    width: 100%;
}

.traceback {
    box-sizing: border-box;
    height: 120px;
    margin: 0;
    padding: 12px 14px;
    font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
    overflow-x: hidden;
    overflow-y: auto;
    color: #34495e;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    white-space: pre-wrap;
    word-break: break-all;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
